import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {VehiclesAiEventsResponse} from './model/vehicles-ai-events.response';
import {LatestVehicleEntry} from "../latest-vehicles-info/model/latest-vehicle-entry";
import {AiEventsUpdateEntry} from "./model/ai-events-update.entry";
import {UndoStatusRequestEntry} from "./model/undo-status-request.entry";

@Injectable({ providedIn: 'root' })
export class AiEventsService {

  private aiEventsStateSource = new BehaviorSubject<string>('out');
  public aiEventsState$ = this.aiEventsStateSource.asObservable();

  private openAiEventsSource = new Subject<LatestVehicleEntry>();
  private openAiEvents$ = this.openAiEventsSource.asObservable();

  private stopAiEventsSource = new Subject<any>()
  public stopAiEvents$ = this.stopAiEventsSource.asObservable();

  private openTasksSource = new Subject<LatestVehicleEntry>();
  public openTasks$ = this.openTasksSource.asObservable();

  constructor(private http: HttpClient) {
  }

  public initOpenAiEvents(vehicle: LatestVehicleEntry): void {
    this.openAiEventsSource.next(vehicle);
  }

  public openAiEvents(): Observable<LatestVehicleEntry> {
    return this.openAiEvents$;
  }

  public stopAiEvents(): void {
    this.stopAiEventsSource.next(true);
  }

  public changeState(state: string) {
    this.aiEventsStateSource.next(state);
  }

  public getCurrentState(): string {
    return this.aiEventsStateSource.getValue();
  }

  public initOpenTasks(vehicle: LatestVehicleEntry): void {
    this.openTasksSource.next(vehicle);
  }

  public fetchVehiclesAIEvents(vehicleId: number): Observable<VehiclesAiEventsResponse[]> {
    return this.http.get<VehiclesAiEventsResponse[]>(`/api/ai-events/${vehicleId}`)
  }

  public updateAiEvents(vehicleId: number, lastShown: number): Observable<AiEventsUpdateEntry> {
    return this.http.get<AiEventsUpdateEntry>(`/api/ai-events/update-ai-events?vehicleId=${vehicleId}&lastShown=${lastShown}`);
  }

  public addAiEvents(vehicleId: number, lastAiEvent: number, scrolledUp: boolean): Observable<VehiclesAiEventsResponse[]> {
    return this.http.get<VehiclesAiEventsResponse[]>(`/api/ai-events/add` +
    `?vehicleId=${vehicleId}` +
    `&lastAiEvent=${lastAiEvent}` +
    `&scrolledUp=${scrolledUp}`);
  }

  public undoStatus(vehicleId: number, request: UndoStatusRequestEntry): Observable<void> {
    return this.http.post<void>(`/api/ai-events/undo-status?vehicleId=${vehicleId}`, request);
  }
}
